module.exports = __webpack_public_path__ + "static/media/Recurso 4.d9da812f.svg";